import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {getAmplitudeDeviceId, getAmplitudeUserId, getResolvedFeatureFlags, waitForAmplitudeInitialization} from "@pg-mono/amplitude";
import type {IDevToolsConfig} from "@pg-mono/devtools";
import {resolveDevtoolsEnabled} from "@pg-mono/devtools";
import {getCookie} from "@pg-mono/request";

import {ongoingABTests} from "../common/ab_testing/ongoing_ab_tests";
import {amplitudeApiKey, buildImageTag, rpFeatureFlagDevtools} from "../common/app/read_rp_environment_variables";

declare global {
    interface Window {
        __AMPLITUDE_FETCHED_FLAGS__?: string[];
    }
}

const getABTestCurrentVariant = (testId: string, variants: string[]): string | null => {
    const cookieValue = getCookie(testId);

    if (cookieValue === null) {
        return null;
    }

    // Legacy cookies may store variant index instead of name - resolve to name
    const index = parseInt(cookieValue, 10);

    if (String(index) === cookieValue && index >= 0 && index < variants.length) {
        return variants[index];
    }

    return cookieValue;
};

export const initRpDevtools = () => {
    const {isEnabled, isForced} = resolveDevtoolsEnabled(rpFeatureFlagDevtools);

    if (!isEnabled) {
        return;
    }

    const amplitudeFetchedFlags = window.__AMPLITUDE_FETCHED_FLAGS__ ?? [];
    delete window.__AMPLITUDE_FETCHED_FLAGS__;

    void waitForAmplitudeInitialization()
        .catch(() => undefined)
        .then(() => import("@pg-mono/devtools"))
        .then(({initDevTools}) => {
            const config: IDevToolsConfig = {
                isForced,
                buildImageTag,
                amplitude: {
                    isInitialized: Boolean(amplitudeApiKey),
                    apiKeyHint: amplitudeApiKey ? amplitudeApiKey.slice(-4) : undefined,
                    deviceId: getAmplitudeDeviceId(),
                    userId: getAmplitudeUserId()
                },
                amplitudeEvents: [],
                abTests: ongoingABTests.map((test: IABTestConfiguration) => ({
                    id: test.id,
                    name: test.name,
                    expires: test.expires,
                    path: test.path,
                    matchOnAllPaths: test.matchOnAllPaths,
                    variants: test.variants,
                    withSSR: test.withSSR,
                    useAmplitude: test.useAmplitude,
                    amplitudeVariantAvailable: test.useAmplitude ? amplitudeFetchedFlags.includes(test.id) : undefined,
                    currentVariant: getABTestCurrentVariant(test.id, test.variants)
                })),
                featureFlags: Object.values(getResolvedFeatureFlags()),
                envVars: window.__INITIAL_ENV__
            };

            initDevTools(config);
        });
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {getAmplitudeDeviceId, getAmplitudeUserId, getResolvedFeatureFlags, waitForAmplitudeInitialization} from "@pg-mono/amplitude";
import type {IDevToolsConfig} from "@pg-mono/devtools";
import {resolveDevtoolsEnabled} from "@pg-mono/devtools";
import {getCookie} from "@pg-mono/request";

import {ongoingABTests} from "../common/ab_testing/ongoing_ab_tests";
import {amplitudeApiKey, buildImageTag, rpFeatureFlagDevtools} from "../common/app/read_rp_environment_variables";

declare global {
    interface Window {
        __AMPLITUDE_FETCHED_FLAGS__?: string[];
    }
}

const getABTestCurrentVariant = (testId: string, variants: string[]): string | null => {
    const cookieValue = getCookie(testId);

    if (cookieValue === null) {
        return null;
    }

    // Legacy cookies may store variant index instead of name - resolve to name
    const index = parseInt(cookieValue, 10);

    if (String(index) === cookieValue && index >= 0 && index < variants.length) {
        return variants[index];
    }

    return cookieValue;
};

export const initRpDevtools = () => {
    const {isEnabled, isForced} = resolveDevtoolsEnabled(rpFeatureFlagDevtools);

    if (!isEnabled) {
        return;
    }

    const amplitudeFetchedFlags = window.__AMPLITUDE_FETCHED_FLAGS__ ?? [];
    delete window.__AMPLITUDE_FETCHED_FLAGS__;

    void waitForAmplitudeInitialization()
        .catch(() => undefined)
        .then(() => import("@pg-mono/devtools"))
        .then(({initDevTools}) => {
            const config: IDevToolsConfig = {
                isForced,
                buildImageTag,
                amplitude: {
                    isInitialized: Boolean(amplitudeApiKey),
                    apiKeyHint: amplitudeApiKey ? amplitudeApiKey.slice(-4) : undefined,
                    deviceId: getAmplitudeDeviceId(),
                    userId: getAmplitudeUserId()
                },
                amplitudeEvents: [],
                abTests: ongoingABTests.map((test: IABTestConfiguration) => ({
                    id: test.id,
                    name: test.name,
                    expires: test.expires,
                    path: test.path,
                    matchOnAllPaths: test.matchOnAllPaths,
                    variants: test.variants,
                    withSSR: test.withSSR,
                    useAmplitude: test.useAmplitude,
                    amplitudeVariantAvailable: test.useAmplitude ? amplitudeFetchedFlags.includes(test.id) : undefined,
                    currentVariant: getABTestCurrentVariant(test.id, test.variants)
                })),
                featureFlags: Object.values(getResolvedFeatureFlags()),
                envVars: window.__INITIAL_ENV__
            };

            initDevTools(config);
        });
};
